<template>
  <DashboardItem
    title="Renewals"
    :loaded="loaded"
  >
    <template #content>
      <div v-if="total > 0">
        <p v-if="total === 1">
          Your renewal date is:
        </p>
        <p v-else>
          Here is your next policy renewal:
        </p>
        <table>
          <tr
            v-for="(policy) in results"
            :key="policy.policyNumber"
          >
            <td>
              <span class="summary-title">Renewal Date</span>
              {{ formatDateToString(policy.renewalDate, 'Do MMMM YYYY') }}
            </td>
            <td>
              <b-button @click="goToPolicy(policy)">
                Details
              </b-button>
            </td>
          </tr>
        </table>
      </div>
      <p v-else>
        You have no policies due for renewal
      </p>
    </template>
  </DashboardItem>
</template>

<script lang="ts">
import type PolicySummary from '@/services/values/PolicySummary'
import {
  Component,
  Vue,
} from 'vue-property-decorator'
import { formatDateToString } from '@/composables/date-utils'
import Routes from '@/constants/Routes'
import NotAuthorisedError from '../../services/error/NotAuthorisedError'
import DashboardItem from './DashboardItem.vue'

@Component({
  components: {
    DashboardItem,
  },
})
export default class Renewals extends Vue {
  results: PolicySummary[] = []

  total = 0

  loaded = false

  formatDateToString = formatDateToString

  get policiesRoute() {
    return {
      name: Routes.policies,
    }
  }

  async created() {
    try {
      const response = await this.$services.policyService.getRenewals(0, 0)
      this.results = response.results
      this.total = response.total
      this.loaded = true
    }
    catch (error) {
      if (!(error instanceof NotAuthorisedError))
        throw error
    }
  }

  goToPolicy(policy: PolicySummary) {
    this.$router.push({
      name: Routes.policy,
      params: {
        product: policy.product,
        policyNumber: policy.policyNumber,
      },
    })
  }
}
</script>
